import { useTranslation } from "react-i18next";
import { Button } from "@akuna/ui";
import { PLAN_TONE } from "@/components/packages/plan-card/planTone";
import type { StayPlanContract } from "@/hooks/useStayPlanContracts";
import { formatDateBR } from "@/lib/date-utils";

export interface PlanHistoryRowProps {
  contract: StayPlanContract;
  expanded: boolean;
  onToggle: () => void;
}

/**
 * Plano encerrado como linha, e não como card inteiro: o histórico de um pet
 * com muitos planos virava uma pilha de cards altos. O detalhe continua a um
 * clique de distância.
 */
export function PlanHistoryRow({ contract, expanded, onToggle }: PlanHistoryRowProps) {
  const { t } = useTranslation("patients");
  const { Icon } = PLAN_TONE[contract.module];

  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1.5 border-b border-border bg-background px-4 py-3.5 last:border-b-0 sm:px-5">
      <Icon className="h-4 w-4 shrink-0 text-color-light" aria-hidden />
      <span className="text-[0.8125rem] font-semibold text-foreground">{contract.planName}</span>
      <span className="text-xs text-muted-foreground">
        {t("stayPlans.historySince", { date: formatDateBR(contract.startsOn) })}
      </span>
      <span className="ms-auto rounded-full bg-cream-100 px-2.5 py-0.5 text-xs font-semibold text-color-medium">
        {t("daycarePlans.statusEnded")}
      </span>
      <Button type="button" size="sm" variant="link" aria-expanded={expanded} onClick={onToggle}>
        {t(expanded ? "stayPlans.hideDetails" : "stayPlans.seeDetails")}
      </Button>
    </div>
  );
}
